import { createLocalStorageFlag } from '@/services/localStorageFlag'

/** Hides the My Path sidebar icon; the page and its route stay reachable. ON unless stored `false`. */
export const myPathShownService = createLocalStorageFlag('nopressure:app-mypath-shown', () => true)
